<template>
  <div>
    <b-container>
      <b-row class="my-3">
        <b-col cols="12" md="6" lg="4">
          <b-container>
            <b-row no-gutters class="position-relative">
              <b-col cols="2" class=""
                ><b-img
                  v-bind="mainProps"
                  src="../assets/img/icons/Iconos_servicios/1.png"
                  alt="Trámites"
                ></b-img
              ></b-col>
              <b-col
                cols="10"
                class="bold d-flex align-items-end cards-title cards-title-space"

                >{{ content[0].title }}</b-col
              >
            </b-row>
            <b-row no-gutters class="justify-content-end">
              <b-col cols="10" class="cards-text mb-4">{{
                content[0].body
              }}</b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <b-container>
            <b-row no-gutters class="position-relative">
              <b-col cols="2" class=""
                ><b-img
                  v-bind="mainProps"
                  src="../assets/img/icons/Iconos_servicios/2.png"
                  alt="Reconocimiento previo de mercancía"
                ></b-img
              ></b-col>
              <b-col
                cols="10"
                class="bold d-flex align-items-end cards-title cards-title-space"
                >{{ content[1].title }}</b-col
              >
            </b-row>
            <b-row no-gutters class="justify-content-end">
              <b-col cols="10" class="cards-text mb-4">{{
                content[1].body
              }}</b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <b-container>
            <b-row no-gutters class="position-relative">
              <b-col cols="2" class=""
                ><b-img
                  v-bind="mainProps"
                  src="../assets/img/icons/Iconos_servicios/3.png"
                  alt="Logística"
                ></b-img
              ></b-col>
              <b-col
                cols="10"
                class="bold d-flex align-items-end cards-title cards-title-space"
                >{{ content[2].title }}</b-col
              >
            </b-row>
            <b-row no-gutters class="justify-content-end">
              <b-col cols="10" class="cards-text mb-4">{{
                content[2].body
              }}</b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col cols="12" md="6" lg="4">
          <b-container>
            <b-row no-gutters class="position-relative">
              <b-col cols="2" class=""
                ><b-img
                  v-bind="mainProps"
                  src="../assets/img/icons/Iconos_servicios/4.png"
                  alt="Cotizaciones"
                ></b-img
              ></b-col>
              <b-col
                cols="10"
                class="bold d-flex align-items-end cards-title cards-title-space"
                >{{ content[3].title }}</b-col
              >
            </b-row>
            <b-row no-gutters class="justify-content-end">
              <b-col cols="10" class="cards-text mb-4">{{
                content[3].body
              }}</b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <b-container>
            <b-row no-gutters class="position-relative">
              <b-col cols="2" class=""
                ><b-img
                  v-bind="mainProps"
                  src="../assets/img/icons/Iconos_servicios/5.png"
                  alt="Punto a punto"
                ></b-img
              ></b-col>
              <b-col
                cols="10"
                class="bold d-flex align-items-end cards-title cards-title-space"
                >{{ content[4].title }}</b-col
              >
            </b-row>
            <b-row no-gutters class="justify-content-end">
              <b-col cols="10" class="cards-text mb-4">{{
                content[4].body
              }}</b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <b-container>
            <b-row no-gutters class="position-relative">
              <b-col cols="2" class=""
                ><b-img
                  v-bind="mainProps"
                  src="../assets/img/icons/Iconos_servicios/6.png"
                  alt="Unidad de verificación"
                ></b-img
              ></b-col>
              <b-col
                cols="10"
                class="bold d-flex align-items-end cards-title cards-title-space"
                >{{ content[5].title }}</b-col
              >
            </b-row>
            <b-row no-gutters class="justify-content-end">
              <b-col cols="10" class="cards-text mb-4">{{
                content[5].body
              }}</b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainProps: { width: 45, height: 45 },
      content: [
        {
          id: 0,
          title: "Trámites",
          body:
            "Padrones ante el SAT, Permisos ante Secretaría de Economía y autorizaciones ante COFEPRIS.",
        },
        {
          id: 1,
          title: "Reconocimiento previo de mercancía",
          body:
            "Conteo de mercancía, generación de etiquetas y verificación de la calidad.",
        },
        {
          id: 2,
          title: "Logística",
          body:
            "Aseguramiento de mercancías, transporte a bodega, seguridad de custodia.",
        },
        {
          id: 3,
          title: "Cotizaciones",
          body:
            "Para fletes terrestres, marítimos y aéreos, siempre buscando el mejor costo.",
        },
        {
          id: 4,
          title: "Punto a punto",
          body:
            "Seguimiento desde la salida de fábrica en el extranjero hasta la llegada a la bodega en territorio nacional.",
        },
        {
          id: 5,
          title: "Unidad de verificación",
          body:
            "Emisión de Contratos y Solicitudes de Servicio, así como Constancias de Cumplimiento y Dictámenes.",
        },
      ],
    };
  },
};
</script>